<template>
  <v-app color="primary">
    <!-- Verificador de versiones -->
    <VersionChecker v-if="isAuthenticated && currentRouteName !== 'gestionPortal'" />

    <!-- Notificaicones -->
    <!-- `ingresando` cubre todo el tramo del login. No alcanza con `loading`:
         getUser lo apaga al terminar y el login quedaba destapado un instante
         antes de que cambiara la ruta. -->
    <Overlay v-if="loading || ingresando" />
    <DialogoOpcionNivel />
    <SnackBar :message="snackMessage" :type="snackType" timeout="5000"></SnackBar>

    <!--Nav-->
    <!-- <NuevoNav v-if="isAuthenticated && currentRouteName !== 'login'" /> -->
    <!-- En gestionPortal el padre solo renderiza el iframe + su banner;
         la Nav del afiliado se ve adentro del iframe, no en el padre. -->
    <Nav v-if="isAuthenticated && currentRouteName !== 'login' && currentRouteName !== 'gestionPortal'"></Nav>
    <NavLogin
      v-if="((currentRouteName == 'login') || (currentRouteName == 'preafiliacion') || (currentRouteName == 'recuperarPassword') || (currentRouteName == 'cambiarPassword')) && !$vuetify.breakpoint.mdAndUp"
      :route="currentRouteName">
    </NavLogin>
    <NavPreAfi v-if="(currentRouteName == 'formularioAfiliacion')"></NavPreAfi>
    <v-main>
      <transition :name="transitionName" mode="out-in">
        <router-view class="app" />
      </transition>
    </v-main>
    <!--     <BottomNav v-if="isAuthenticated" /> -->
    <!--   <FooterPreAfi v-if="currentRouteName == 'formularioAfiliacion'" />  -->
  </v-app>
</template>
<style lang="sass">
  @import '@/scss/variables.scss'
</style>

<style>
/* Fade global entre rutas. mode="out-in" en el <transition> hace que la
   vista vieja termine de salir antes de que entre la nueva (sin overlap). */
.route-fade-enter-active,
.route-fade-leave-active {
  transition: opacity 0.12s ease-in-out;
}

.route-fade-enter,
.route-fade-leave-to {
  opacity: 0;
}

/* Blur entre /login y /recuperarPassword. Combina blur+opacidad parcial para
   que la pantalla no quede vacia durante el cross-route (sigue visible una
   silueta desenfocada de la vista saliente). */
.auth-blur-enter-active,
.auth-blur-leave-active {
  transition: filter 0.10s ease, opacity 0.10s ease;
}

.auth-blur-enter,
.auth-blur-leave-to {
  filter: blur(8px);
  opacity: 0;
}
</style>

<script>

import Nav from '@/components/navigations/Nav.vue'
import NavLogin from '@/components/navigations/NavLogin.vue'
import NavPreAfi from '@/components/navigations/NavPreAfi.vue'
import BottomNav from '@/components/navigations/BottomNav.vue'
import FooterPreAfi from '@/components/navigations/FooterPreAfi.vue'
import SnackBar from '@/components/alerts/SnackBar.vue';
import Overlay from '@/components/alerts/Overlay.vue';
import VersionChecker from '@/components/VersionChecker.vue';
import DialogoOpcionNivel from '@/components/dialogos/DialogoOpcionNivel.vue';
import NuevoNav from '@/components/navigations/NuevoNav.vue'
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'App',
  data: () => ({
    titulo: '',
    width: '',
    hiddenTime: null,
    INACTIVITY_LIMIT_MS: 15 * 60 * 1000, // 15 minutos
    transitionName: 'route-fade',
  }),

  components: {
    Nav,
    NavLogin,
    NavPreAfi,
    NuevoNav,
    BottomNav,
    SnackBar,
    VersionChecker,
    Overlay,
    DialogoOpcionNivel,
    FooterPreAfi
  },
  beforeMount() {

  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    document.removeEventListener("swUpdated", this.handleSwUpdated);
  },

  watch: {
    // También verificar cuando el usuario inicia sesión
    isAuthenticated(newVal) {
      if (newVal) {
        this.verificarTramitesPendientes();
      }
    },
    // Selector de transicion entre rutas: blur cuando navega entre login y
    // recuperarPassword (en cualquier direccion), fade en cualquier otro caso.
    $route(to, from) {
      const authPair = ['login', 'recuperarPassword'];
      const cruzaAuth = authPair.includes(to.name) && authPair.includes(from.name);
      this.transitionName = cruzaAuth ? 'auth-blur' : 'route-fade';

      // Actualizacion de PWA diferida durante la sesion: aplicarla al volver
      // al login (logout o expiracion), donde recargar no interrumpe nada.
      if (to.name === 'login' && localStorage.getItem('pwa_update_pending')) {
        this.recargarPorActualizacion();
      }
    },
  },

  mounted() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    document.addEventListener("swUpdated", this.handleSwUpdated);
    // Si quedo pendiente una actualizacion de una sesion anterior y la app
    // arranca en login, aplicarla de entrada.
    if (!this.isAuthenticated && localStorage.getItem('pwa_update_pending')) {
      this.recargarPorActualizacion();
    }
    // En gestionPortal el padre es solo el "shell" del operador —
    // no debe consumir la sesion del afiliado. Eso es trabajo del
    // iframe que se monta adentro como instancia separada de la app.
    if (this.$route.name === 'gestionPortal') return;
    //  reviso si hay token en sessionStorage
    // cada vez que se recarga la pagina
    if (sessionStorage.getItem('token')) {
      //decodifico el token
      this.decodeToken(sessionStorage.getItem('token'))
      // Cargar email principal del afiliado
      this.$store.dispatch('getEmail')
    }

  },
  beforeCreate() {
    // adan 05/08/22
    // forzamos el dominio para no tenere problemas con el CORS
    //document.domain = 'cajapsipba.org.ar';
    //document.domain = 'cajapsipba.org.ar';
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
    //mapeo los getters del store
    ...mapGetters('auth', ['isAuthenticated', 'ingresando']),
    ...mapGetters('notificaciones', ['snackMessage', 'snackType', 'loading']),
  },
  methods: {
    //mapeo los actions
    ...mapActions('auth', ['decodeToken', 'cerrarSesion']),
    ...mapActions('tramites', ['getTramites']),

    handleSwUpdated() {
      // El SW nuevo ya esta activo; falta una recarga para tomar el bundle
      // nuevo. En login (o sin autenticar) recargamos ya; dentro de una
      // sesion lo diferimos para no interrumpir un tramite en curso.
      if (!this.isAuthenticated && this.currentRouteName !== 'gestionPortal') {
        this.recargarPorActualizacion();
      } else {
        localStorage.setItem('pwa_update_pending', '1');
      }
    },

    recargarPorActualizacion() {
      localStorage.removeItem('pwa_update_pending');
      this.$store.dispatch('notificaciones/showSnack', {
        message: 'Nueva versión disponible. Actualizando...',
        type: 'info'
      });
      setTimeout(() => window.location.reload(), 1200);
    },

    handleVisibilityChange() {
      if (document.hidden) {
        // Se ocultó la pestaña
        this.hiddenTime = Date.now();
      } else {
        // Volvió a ser visible
        if (this.hiddenTime !== null) {
          const timeAway = Date.now() - this.hiddenTime;
          if (timeAway > this.INACTIVITY_LIMIT_MS) {
            if (this.isAuthenticated) {
              // Si el usuario estaba autenticado, cerramos sesión
              this.cerrarSesion();
            }
          }
        }
        this.hiddenTime = null;
      }
    },
    clearAllInputs() {
      const inputs = document.querySelectorAll("input");
      inputs.forEach(el => el.value = "");
    },

    async verificarTramitesPendientes() {
      try {
        await this.getTramites();
      } catch (error) {
        console.error('Error al verificar trámites pendientes:', error);
      }
    }

  },
}
</script>